import React, {useEffect, useState} from 'react'
import "../css/PostManager.css";
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";
import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";
import {useParams} from "react-router-dom";


const PostManager = () => {
    const {postId} = useParams();
    const [selectedPost, setSelectedPost] = useState(null)
    const [editing, setEditing] = useState(false)
    const [editedContent, setEditedContent] = useState('')
    const [editedImage, setEditedImage] = useState('')
    const [posts, setPosts] = useState([])
    const [get, setGet] = useState(true)
    const handlePostClick = (post) => {
        setSelectedPost(post)
        setEditedContent(post.content)
        setEditedImage(post.image)
        setEditing(false)
    }

    const handleSave = async () => {
        setSelectedPost({
            ...selectedPost,
            content: editedContent,
            image: editedImage
        })
        setEditing(false)
        const token = getTokenFromSession()
        try {
            const res = await axiosInstance.put(`${api.post}`, selectedPost, {
                headers: {
                    Authorization: `${token}`,
                    "Content-Type": "application/json",
                }
            })
            if (res.status === 200) {
                alert("updated successfully")
            }
        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                const refreshToken = getRefreshToken();
                sessionStorage.setItem("intendedPage", `/theme`);

                if (!refreshToken) {
                    alert("Session expired. Please log in again.");
                    window.location.href = "/";
                    return;
                }
                try {
                    await refreshIdToken(refreshToken);
                    await handleSave();
                } catch (refreshErr) {
                    console.error("Token refresh failed:", refreshErr);
                    window.location.href = "/";
                }
            }
        }
    }

    const handlePostToInstagram = () => {
        alert('Posting to Instagram API...')
    }

    useEffect(() => {
        const fetchData = async () => {
            const token = getTokenFromSession()
            try {
                const res = await axiosInstance.get(`${api.post}`, {
                    headers: {
                        Authorization: `${token}`,
                        "content-type": "application/json"
                    }
                })
                const grouped = {};
                res.data.forEach((post) => {
                    const date = new Date(post.postedDate).toISOString().split('T')[0];
                    if (!grouped[date]) {
                        grouped[date] = []
                    }
                    grouped[date].push({
                        id: post.postId,
                        title: post.themeName,
                        image: post.imageUrl || "",
                        content: post.content
                    })
                })
                const formattedPosts = Object.keys(grouped)
                    .sort((a, b) => new Date(b) - new Date(a))
                    .map(date => ({
                        date,
                        posts: grouped[date]
                    }));
                setPosts(formattedPosts)

                if (postId) {
                    const allPosts = formattedPosts.flatMap(group => group.posts);
                    const foundPost = allPosts.find(post => post.id === postId);
                    if (foundPost) {
                        setSelectedPost(foundPost);
                        setEditedContent(foundPost.content);
                        setEditedImage(foundPost.image);
                    }
                }
                setGet(false)
            } catch (error) {
                if (error.response?.status === 401 || error.response?.status === 403) {
                    const refreshToken = getRefreshToken();
                    if(postId){
                        sessionStorage.setItem("intendedPage", `/instagramPost/${postId}`);
                    } else {
                        sessionStorage.setItem("intendedPage", `/instagramPost`);
                    }


                    if (!refreshToken) {
                        alert("Session expired. Please log in again.");
                        window.location.href = "/";
                        return;
                    }
                    try {
                        await refreshIdToken(refreshToken);
                        await fetchData();
                    } catch (refreshErr) {
                        console.error("Token refresh failed:", refreshErr);
                        window.location.href = "/";
                    }
                }
            }
        }
        if (get) {
            fetchData().then()
        }
    }, [postId])

    return (
        <div>
            <div>
                <Header/>
            </div>
            <div style={{marginTop: "40px"}}>
                <NavBar/>
            </div>
            <div className="post-manager" style={{marginTop: "40px"}}>
                <div className="sidebar">
                    <h3>Posts by Date</h3>
                    <div className="tree-view">
                        {posts.map((dateGroup) => (
                            <div key={dateGroup.date} className="date-group">
                                <div className="date">{dateGroup.date}</div>
                                <div className="posts">
                                    {dateGroup.posts.map((post) => (
                                        <div
                                            key={post.id}
                                            className={`post ${selectedPost?.id === post.id ? 'selected' : ''}`}
                                            onClick={() => handlePostClick(post)}
                                        >
                                            {post.title}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="main-content">
                    {selectedPost ? (
                        <div className="post-view">
                            <div className="post-image">
                                {editing ? (
                                    <input
                                        type="text"
                                        value={editedImage}
                                        onChange={(e) => setEditedImage(e.target.value)}
                                        placeholder="Image URL"
                                    />
                                ) : (
                                    <img src={selectedPost.image} alt={selectedPost.title}/>
                                )}
                            </div>
                            <div className="post-content">
                                {editing ? (
                                    <textarea
                                        value={editedContent}
                                        onChange={(e) => setEditedContent(e.target.value)}
                                        placeholder="Post content"
                                    />
                                ) : (
                                    <p>{selectedPost.content}</p>
                                )}
                            </div>
                            <div className="post-actions">
                                {editing ? (
                                    <>
                                        <button onClick={handleSave}>Save</button>
                                        <button onClick={() => setEditing(false)}>Cancel</button>
                                    </>
                                ) : (
                                    <>
                                        <button onClick={() => setEditing(true)}>Edit</button>
                                        <button onClick={handlePostToInstagram}>Post to Instagram</button>
                                    </>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="empty-state">Select a post to view</div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PostManager;